import * as React from 'react';

import { InputText } from 'primereact/inputtext';
import { ListBox } from 'primereact/listbox';
import { Button } from 'primereact/button';

function SearchBar({items, selectedItem, setSelectedItem, endpoint, label}) {
    const [query, setQuery] = React.useState('');

    const filterData = (query, items) => {
        return (!query) ? items : items.filter((item) => item.name.toLowerCase().includes(query.toLowerCase()));
    };

    return (
        <div>
            <p>Available {label}s</p>
            <div style={{ marginBottom: '2rem'}}>
                <div style={{ marginBottom: '1rem'}}>
                <InputText onChange={(event) => setQuery(event.target.value)} placeholder={`Enter ${label} name`} style={{ width: '200px', marginRight: '0.5rem' }}/>
                <Button label={`Parse ${label}`} onClick={() => endpoint(selectedItem.id)} disabled={!selectedItem}/>
                </div>
                <label>Selected {label}: {selectedItem ? selectedItem.name : 'None'}</label>
            </div>
            <ListBox
                value={selectedItem}
                onChange={(event) => setSelectedItem(event.target.value)}
                options={filterData(query, items).map((item) => ({label: item.name, value: item}))}
                optionLabel="label"
                optionValue="value"
                style={{ margin: '0 auto', width: '500px', height: '400px', overflowY: 'auto'}}
            />
        </div>
    )
}

export default SearchBar;